// extracted by mini-css-extract-plugin
export default {"container":"title-plate_container__-FHq4","plaque":"title-plate_plaque__2SjxS"};